export default {
	maxDateMessage: "Data nie powinna być późniejsza niż data maksymalna.",
	minDateMessage: "Data nie powinna być wcześniejsza niż data minimalna.",
}